'use client';

import { Trans } from 'next-i18next';

/**
 * @description Marketing slogan component for the login page. Ex: 'let b upgrade you'.
 */
export const AuthMarketingSlogan = () => (
  <h1 className="text-xl text-dark lg:text-2xl">
    <Trans
      i18nKey="login.bestie.title"
      components={{
        br: <br />,
        span: <span className="underline decoration-secondary decoration-wavy" />,
      }}
    />
  </h1>
);

